import React, {
  useState, useRef,
} from 'react'

import Heading from '@/UI/Heading'
import TextContentModal from '@/Modals/TextContentModal'
import {
  StyledParagraphWithTitle, StyledParagraphWithTitleContent
} from './styles'

const ParagraphsWithTitle = ({
  title,
  description,
  textContentModal = null
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const paragraphRef = useRef(null)

  return (
    <StyledParagraphWithTitle>
      <Heading as="h2" size={'customSmall'}>{title}</Heading>
      <StyledParagraphWithTitleContent ref={paragraphRef} dangerouslySetInnerHTML={{ __html: description }} />

      {
        !!textContentModal &&
        !!textContentModal?.description &&
        <>
          <button onClick={() => setIsOpen(true)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <rect y="0.5" width="24" height="24" rx="12" fill="#26376D" />
              <path
                d="M12 7L12 19"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M6 13H18"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            <span>{textContentModal.openModalLabel}</span>
          </button>


          <TextContentModal
            data={{ ...textContentModal }}
            isOpen={isOpen}
            modalHandler={() => setIsOpen(false)}
          />
        </>
      }

    </StyledParagraphWithTitle>
  )
}

export default ParagraphsWithTitle
